import * as React from 'react'

import { observer } from 'mobx-react'

import BaseGroupingOptions from '~/client/src/desktop/components/BaseGroupingOptions/BaseGroupingOptions'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'

import AttachmentsGroupingOptionsStore from './AttachmentsGroupingOptions.store'

// localization: no display text to translate

interface IProps {
  store: AttachmentsGroupingOptionsStore
  forceClose: boolean
  CustomHandleButton?: typeof Button
  leftIcon?: JSX.Element
}

const AttachmentsGroupingOptions: React.FC<IProps> = observer(
  ({ store, forceClose, CustomHandleButton, leftIcon }) => {
    return (
      <BaseGroupingOptions
        store={store}
        forceClose={forceClose}
        CustomHandleButton={CustomHandleButton}
        leftIcon={leftIcon}
        shouldHideBandCreation
        shouldRenderRightIcon
      />
    )
  },
)

export default AttachmentsGroupingOptions
